import { render } from "./DeveloperItemSelect.vue?vue&type=template&id=c5198dce"
import script from "./DeveloperItemSelect.vue?vue&type=script&lang=js"
export * from "./DeveloperItemSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__